<template>
	<div>
		<!-- <van-image
			v-if="departmentDetail.topEntrance"
			class="header-image"
			:src="departmentDetail.topEntrance"
			@click="goDepartmentDetail"
		/> -->
		<div class="physician_visits_home">
			<!--患者基础信息-->
			<HomePatientBase type="homeStyle" @onChange="patientChange" />
			<!-- 医生卡片 -->
			<HomeDoctorCard class="mt-28" :type="bindType" :detail="bindDetail"></HomeDoctorCard>

			<!--预约提醒弹窗-->
			<HomeSubscribeDialog ref="homeSubscribeDialog"></HomeSubscribeDialog>
			<!-- 服务包 -->
			<ServicePackList
				title="推荐服务"
				:list="getServicePackList"
				:videoNumber="serviceChatNumber.videoNumber"
				:voiceNumber="serviceChatNumber.voiceNumber"
				class="mt-28"
			/>
			<!--预约列表-->
			<div class="subscribe_list mt-28" v-if="timeList.length>0">
				<div class="title line-bottom">预约咨询</div>
				<HomeSubscribeItem
					v-for="(item) in timeList"
					:key="item.targetId"
					:id="item.targetId"
					:orderId="item.consultOrderId"
					:label="item.serviceName"
					:status="item.taskStatus"
					:desc="homeSubscribeItemDateTimeFormat(item)"
					class="line-bottom"
				/>
			</div>
			<!-- 我的任务 -->
			<HomeTaskCard :data="taskDateil" @changeTab="changeTab" @refresh="getTask" />

			<!--已经购买的服务包列表-->

			<!--未购买的服务包列表-->
			<!-- <ServicePackList
				title="推荐服务"
				class="mt-28"
				:visible="!!getNotServicePackList.length || !!getNotServiceItemList.length"
				:list="getNotServicePackList"
				:item-list="getNotServiceItemList"
			/> -->
		</div>
	</div>
</template>

<script>
import HomePatientBase from '../main/components/patient-base.vue'
import HomeSubscribeItem from './components/home-subscribe-item.vue'
import HomeSubscribeDialog from './components/home-subscribe-dialog.vue'
import ServicePackList from './components/service-pack-list.vue'
import HomeTaskCard from './components/home-task-card.vue'
// import DepartmentDetailDialog from './components/department-detail-dialog.vue'
import HomeDoctorCard from './components/home-doctor-card.vue'
export default {
    name: 'physicianVisitsHome',
    components: { ServicePackList, HomePatientBase, HomeSubscribeDialog, HomeTaskCard, HomeDoctorCard, HomeSubscribeItem },
    data: () => ({
        servicePackList: [],
        departmentDetail: {},
        bindDetail: {},
        taskDateil: [],
        showDepartmentDetail: false,
        bindType: '',
        timeList: [],
        serviceChatNumber: {
            videoNumber: 0,
            voiceNumber: 0
        }
    }),
    computed: {
        info () {
            return this.$store.getters['account/patientInfo'] || {}
        },
        // 获取已经购买过的服务包
        getServicePackList () {
            return this.servicePackList
        },
        patientId () {
            return this.$store.getters['account/getPatientId']
        },
        // 获取血压状态
        getBloodPresureState () {
            return Math.max(this.info.highPressureStatus, this.info.lowPressureStatus)
        }
    },
    mounted () {
        this.$store.dispatch('account/actionGetDateTime')
        if (this.info.id) {
            this.patientChange()
        }
    },
    methods: {
        // 预约时间格式化
        homeSubscribeItemDateTimeFormat (item) {
            return `（${this.$moment(item.startTime).format('HH:mm')}-${this.$moment(item.endTime).format('HH:mm')}）`
        },
        // 获取状态
        // homeSubscribeItemStatus (val) {
        //     console.log(val, id)
        //     const c = this.$moment(val).format('x')
        //     const curTime = Number.parseFloat(this.$store.state.account.serveDateTime) + 5 * 60 * 1000
        //     if (curTime < c) return 0
        //     this.$nextTick(() => {
        //         this.$refs.homeSubscribeDialog.init(val)
        //     })
        //     return 1
        // },
        /**
         * @method 更换患者
         */
        patientChange () {
            this.getServiceList()
            this.getTask()
            this.getDoctorOrTeamDetail()
            this.getServiceUsableNumber()
            this.getStartConsult()
        },
        /**
         * @method 获取服务包列表
         * @param { string } id 患者id
         */
        async getServiceList () {
            const res = await this.$api.servicePack.getList({
                page: 1,
                limit: 999,
                state: 1,
                order: 'desc',
                orderField: 'gmt_create'
            })
            if (!res.code) {
                this.servicePackList = res.data.list
            }
        },
        /**
         * @method 检测是否需要科室弹窗
         * @param {string} id 
         */
        async checkDepartmentDialog (id) {
            const { code, data } = await this.$api.doctor.checkDepartmentDialog(id)
            if (!code) {
                this.showDepartmentDetail = data
                this.getDepartment(id)
            }
        },
        /**
         * @method 获取科室详情
         * @param {string} id 
         */
        async getDepartment (id) {
            const { code, data } = await this.$api.doctor.getTeamDetail(id)
            if (!code) {
                this.departmentDetail = data
            }
        },
        //前往科室详情页面
        // goDepartmentDetail () {
        //     this.$router.push({
        //         path: `/my/department/${this.$store.getters['account/getPatientId']}`
        //     })
        // },
        /**
         * 获取资讯记录详情
         * @param {string} id,
         * @param {string} startTime ,
         * @param {number} index
         */
        // async getDetail ({ id, startTime }) {
        // if (this.homeSubscribeItemStatus(startTime, id)) {
        //     const { data } = await this.$api.physicianVisits.getAppointmentInfo(id)
        //     if (data && [3, 4].indexOf(data.appointmentStatus) > -1) {
        //         this.getTask()
        //     }
        // }

        // },
        /**
         * 获取任务列表
         * @param {string} id,
         */
        async getTask () {
            const { code, data } = await this.$api.task.getNoCompleteTask({ patientId: this.patientId })
            if (!code) {
                this.taskDateil = data
            }
        },
        changeTab (type) {
            this.$emit('changeTab', type)
        },

        //获取团队或者医生详情
        getDoctorOrTeamDetail () {
            if (this.info.list && this.info.list.length > 0) {
                let bindObj = this.info.list[0]
                let type = bindObj.bindType
                this.bindType = type
                let list = {
                    doctorInfo: this.$api.doctor.getDoctorInfoById(bindObj.doctorId)
                }
                if (type === 2) {
                    list['teamInfo'] = this.$api.doctor.getTeamDetail(bindObj.teamId)
                }
                this.$http.all(list, res => {
                    let data = {}
                    if (!res.doctorInfo.code) {
                        data = res.doctorInfo.data || {}
                    }
                    if (res.teamInfo && !res.teamInfo.code) {
                        data['teamInfo'] = res.teamInfo.data
                    }
                    this.bindDetail = data
                })
            }
        },
        //获取剩余咨询次数
        getServiceUsableNumber () {
            this.$api.patient.getServiceUsableNumber({
                id: this.patientId
            }).then(({ code, data }) => {
                if (!code) {
                    this.serviceChatNumber = data
                }
            })
        },
        // 获取已开始的咨询
        getStartConsult () {
            this.$api.patient.getStartConsult({ id: this.patientId }).then(({ code, data }) => {
                if (!code) {
                    this.timeList = data
                    if (this.timeList.length > 0 && this.timeList[0].isStart) {
                        this.$nextTick(() => {
                            this.$refs.homeSubscribeDialog.init(this.timeList[0])
                        })

                    }
                }
            })
        }
    }
};
</script>

<style scoped lang="less">
.physician_visits_home {
	padding: 30px 28px 10px 28px;
	background: linear-gradient(180deg, #05c0ca 28%, rgba(28, 193, 202, 0) 100%);
	background-size: 100vw 526px;
	background-repeat: no-repeat;
	.subscribe_list {
		background-color: #ffffff;
		padding: 0 28px;
		border-radius: 16px;
		.title {
			font-size: 36px;
			color: #1f2329;
			font-weight: 600;
			padding: 32px 0;
		}
		.line-bottom:not(:last-child) {
			border-bottom: 1px solid #eeeeee;
		}
	}
	.service_pack_item {
		& + .service_pack_item {
			margin-top: 28px;
		}
		border-radius: 16px;
		&.primary {
			background-color: mix(@primary, #fff, 5%);
		}
		&.blue {
			background-color: #f7fbff;
		}
		&.pink {
			background-color: #f9f7ff;
		}
	}
	.health_tool {
		.tool_icon {
			> img {
				width: 44px;
				height: 44px;
				vertical-align: middle;
			}
		}
		.tool_text {
			margin-top: 15px;
			font-family: PingFangSC-Regular;
			font-size: 24px;
			font-weight: normal;
			color: #1f2329;
			word-break: break-all;
		}
	}
}
</style>
<style lang="less" scoped>
.physician_visits_home {
	.health_tool {
		.van-grid-item__content {
			padding-left: 0;
			padding-right: 0;
			background-color: transparent;
		}
	}
}
.header-image {
	width: 100%;
	height: 140px;
}
.patient_button_style {
	border: 1px solid #dee0e3;
	padding: 4px 16px;
	border-radius: 22px;
}
.indicator_card {
	.indicator_inner {
		.value {
			font-family: PingFangSC-Semibold;
			font-size: 32px;
			font-weight: normal;
			color: #1f2329;
			.value_unit {
				font-family: PingFangSC-Regular;
				font-size: 24px;
				font-weight: normal;
				color: #1f2329;
				padding-left: 10px;
			}
			.value_tag {
				&.high {
					color: @danger;
				}
				&.normal {
					color: @primary;
				}
				&.low {
					color: @info;
				}
			}
		}
		.nodes {
			font-family: PingFangSC-Regular;
			font-size: 20px;
			font-weight: normal;
			color: #8f959e;
		}
		.unit {
			font-family: PingFangSC-Regular;
			font-size: 24px;
			font-weight: normal;
			color: #1f2329;
		}
		&.fat {
			.value {
				font-size: 24px;
				.value_tag,
				.value_unit {
					font-size: 20px;
				}
			}
		}
	}
}
.cure_item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 26px 28px;
	box-sizing: border-box;
	border-radius: 16px;
	background-color: #caf2f4;
	&.cure_item__info {
		background-color: #d8ecff;
	}
	.cure_item_label {
		.title {
			height: 42px;
			line-height: 42px;
			font-size: 30px;
			font-weight: 600;
			color: #1f2329;
		}
		.time {
			height: 31px;
			line-height: 31px;
			font-size: 22px;
			color: @gray-9;
		}
	}
	.cure_item_icon {
		> img {
			width: 80px;
			height: 80px;
			vertical-align: middle;
		}
	}
}

.indicator_card_1 {
	width: 180px;
	float: left;
}
.mx-15 {
	margin: 0 15px;
}
.indicator_card_2 {
	width: 240px;
	float: left;
}
</style>
<style lang="less">
.badge_dot {
	.van-badge--fixed {
		padding: 0;
	}
	.van-badge--dot {
		width: 20px;
		height: 20px;
	}
}
</style>
